import e from "../../utils/classNames.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/dialog/DialogBody.tsx
var n = ({ className: n = "", children: r, ...i }) => {
	let a = e("modal-body", n);
	return /* @__PURE__ */ t("div", {
		...i,
		className: a,
		"aria-label": "dialog body",
		children: r
	});
};
//#endregion
export { n as default };

//# sourceMappingURL=DialogBody.js.map